<template>
  <div id="blade2b">
    <GroupContainer :obj="stObj.gC">
      <template #slot1>
        <TwelveCol id="shale-quote"></TwelveCol>
        <div class="blade-2b-img-cntnr">
          <img
            :src="stObj.shaleHeadshot"
            alt="Portrait of Shale Williams, a technical specialist at id Software"
            class="blade-2b-plane b4p-left"
            data-aos="fade-up-right"
            data-aos-delay="1000"
            data-aos-duration="2500"
          />
        </div>
        <ThreeBySixByThree>
          <template #slot2>
            <SimpleQuote :obj="stObj.simpQ"></SimpleQuote>
            <p class="custom-citation">
              <span>Shale Williams,</span>
              <span class="title">
                <br />Technical Specialist, id Software
              </span>
            </p>
          </template>
        </ThreeBySixByThree>
      </template>
    </GroupContainer>
  </div>
</template>

<script>
import TwelveCol from "../../../2019-immersive-modular-experience/src/components/TwelveCol";
import ThreeBySixByThree from "../../../2019-immersive-modular-experience/src/components/ThreeBySixByThree";
import GroupContainer from "../../../2019-immersive-modular-experience/src/components/GroupContainer";
import SimpleQuote from "../../../2019-immersive-modular-experience/src/components/SimpleQuote";
import { inView } from "../../helpers/inView";
import bladeAnimations from "../../helpers/bladeAnimations";
import { setUpBlade2bAnimation, blade2banimation } from "../../helpers/blade2b";

export default {
  name: "Blade2b",
  data: function() {
    return {
      hasAnimated: false
    };
  },
  components: {
    TwelveCol,
    GroupContainer,
    ThreeBySixByThree,
    SimpleQuote
  },
  computed: {
    stObj() {
      return this.$store.state.blade2b;
    }
  },
  methods: {
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#blade2b", blade2banimation, "all");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setUpBlade2bAnimation();
      document.addEventListener("scroll", this.checkInView);

      if (window.innerWidth >= 576) {
        bladeAnimations.parallax("#shale-quote");
      }
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.checkInView);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade2b.scss";
</style>